import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#09090B] flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <Card className="bg-[#121214] border-zinc-800 p-12 text-center max-w-md">
        <div className="w-20 h-20 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-12 h-12 text-yellow-500" />
        </div>
        
        <h1 className="text-3xl font-bold font-['Manrope'] mb-3">Payment Cancelled</h1>
        <p className="text-lg text-slate-400 mb-8">
          Your payment was cancelled. No charges were made to your account.
        </p>

        <div className="space-y-3">
          <Button 
            onClick={() => navigate('/pricing')} 
            className="w-full bg-blue-600 hover:bg-blue-700"
            data-testid="try-again-btn"
          >
            Try Again
          </Button>
          <Button 
            onClick={() => navigate('/dashboard')} 
            variant="outline"
            className="w-full border-zinc-700 hover:bg-zinc-800"
          >
            Back to Dashboard
          </Button>
        </div>
      </Card>
    </div>
  );
}
